export default {
	project_name: 'TCL Experts',
	point: 'Star | Stars',
	points: 'Stars',
	point_plural: 'Stars',
	score: 'Stars',
	points_earned: 'Étoiles Gagnées',
	my_points: 'Mes Étoiles',
	points_table: 'Table des Étoiles',
	acc_score: 'Étoile accumulée | Étoiles accumulées',
}
